import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/payment"

export const getPayments = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const getPaymentReports = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await dhFoods.get(`${endpoint}/report/statistic?${query}`)

  return response.data
}

export const pay = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.post(`${endpoint}?${query}`, data)

  return response.data
}

export const approvePayment = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.post(`${endpoint}/approve?${query}`, data)

  return response.data
}

export const getPromotionPackageUsage = async couponCode => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/topupPromotion/${couponCode}/usage`)

  return response.data
}

export const getPromotionPackageUsageList = async (couponCode, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/topupPromotion/${couponCode}/list?${query}`)

  return response.data
}

export const sendPaymentLinkSms = async (orderId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/smsPaymentLink/${orderId}`)

  return response.data
}

export const topupPaymentServiceOwner = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/topup/serviceOwner`, data)

  return response.data
}

export const billplzPaymentStatus = async billId => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/billId/${billId}`)

  return response.data
}

export const sendPosPayment = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/pos/terminal/request`, data)

  return response.data
}

export const sendPosTerminalResult = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/pos/terminal/result`, data)

  return response.data
}

export const sendPosTerminalAcknowledge = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/pos/terminal/acknowledge`, data)

  return response.data
}